import React, { useState, useEffect, useRef } from 'react';
import { useSnackbar } from 'notistack';
import {
  Box,
  FormControl,
  Select,
  InputLabel,
  MenuItem,
  Divider,
  Button,
  ToggleButtonGroup,
  TextField,
  ToggleButton,
} from '@mui/material';
import { getYears } from '../../utils/constCodeUtils';
import * as xlsx from 'xlsx';
import { useDispatch, useSelector } from 'react-redux';
import { getCompanies } from '../../modules/auth';
import SalesManageStaticsHeadquarterContainer from './SalesManageStaticsHeadquarterContainer';
import SalesManageStaticsTeamContainer from './SalesManageStaticsTeamContainer';
import SalesManageStaticsEmpContainer from './SalesManageStaticsEmpContainer';

//------------------------------------------------------------------
const staticsTypes = [
  { name: '본부', type: 'headquarter' },
  { name: '팀', type: 'depart' },
  { name: '팀원', type: 'employee' },
];
//------------------------------------------------------------------
const SalesManageStaticsContainer = () => {
  const hqTableRef = useRef();
  const dpTableRef = useRef();
  const empTableRef = useRef();

  const dispatch = useDispatch();
  const { companies } = useSelector(({ auth }) => ({
    companies: auth.companies,
  }));

  const [companyCd, setCompanyCd] = useState('ALL');
  const [years, setYears] = useState(null);
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
  const [type, setType] = useState('headquarter');

  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [headerRows, setHeaderRows] = useState(null);

  const [searchData, setSearchData] = useState(null);

  useEffect(() => {
    const arrYears = getYears(3, 1);
    setYears(arrYears);
  }, []);

  useEffect(() => {
    if (!companies || companies.length === 0) {
      dispatch(getCompanies());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [companies]);

  const handleCompany = (event) => {
    setCompanyCd(event.target.value);
    searchClickHandler();
  };

  const handleChangeType = (event, newType) => {
    if (newType === '' || newType === null) {
      newType = 'headquarter';
    }
    setType(newType);
    searchClickHandler();
  };

  const handleChangeYear = (event) => {
    setSelectedYear(event.target.value);
    searchClickHandler();
  };

  const handleDownExcel = () => {
    let el;
    let name;
    if (type === 'headquarter') {
      el = hqTableRef;
      name = '본부';
    } else if (type === 'depart') {
      el = dpTableRef;
      name = '팀';
    }
    htmlToExcel(el.current, name);
  };

  const htmlToExcel = (tableEl, name) => {
    const wb = xlsx.utils.table_to_book(tableEl, {
      sheet: 'sheet1',
      raw: true,
    });
    xlsx.writeFile(wb, name + '.xlsx');
  };

  useEffect(() => {
    if (type && companyCd && selectedYear) {
      setSearchData(type + '_' + companyCd + '_' + selectedYear);
    }
  }, []);

  const searchClickHandler = () => {
    setSearchData(type + '_' + companyCd + '_' + selectedYear);
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', my: 2 }}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'flex-start',
            alignItems: 'center',
          }}
        >
          <Box sx={{ mx: 1, minWidth: 120 }}>
            <TextField
              variant="standard"
              fullWidth
              select
              label="회사"
              name="company"
              value={companyCd}
              onChange={handleCompany}
            >
              <MenuItem value="ALL">전체</MenuItem>
              {companies &&
                companies.map((option) => (
                  <MenuItem key={option.companyCd} value={option.companyCd}>
                    {option.companyNm}
                  </MenuItem>
                ))}
            </TextField>
          </Box>

          <Box sx={{ mr: 1, minWidth: 120 }}>
            <FormControl variant="standard" fullWidth>
              <InputLabel id="selected-year-label">기준년도</InputLabel>
              <Select
                labelId="selected-year-label"
                id="selected-year"
                value={selectedYear}
                label="년도"
                onChange={handleChangeYear}
              >
                {years &&
                  years.map((item, index) => (
                    <MenuItem key={index} value={item}>
                      {item}
                    </MenuItem>
                  ))}
              </Select>
            </FormControl>
          </Box>
          <Box sx={{ mx: 1 }}>
            <ToggleButtonGroup
              size="small"
              color="primary"
              value={type}
              exclusive
              onChange={handleChangeType}
            >
              {staticsTypes.map((type, index) => (
                <ToggleButton key={index} value={type.type}>
                  {type.name}
                </ToggleButton>
              ))}
            </ToggleButtonGroup>
          </Box>
        </Box>

        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'flex-start',
            alignItems: 'center',
          }}
        >
          <Box>
            <Button
              variant="contained"
              color="success"
              onClick={handleDownExcel}
            >
              엑셀 다운로드
            </Button>
          </Box>
        </Box>
      </Box>
      <Divider sx={{ my: 1 }} />

      <Box
        sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
      >
        {type === 'headquarter' && (
          <SalesManageStaticsHeadquarterContainer
            selectedYear={selectedYear}
            selectedCompany={companyCd}
            searchData={searchData}
            tableRef={hqTableRef}
          />
        )}
        {type === 'depart' && (
          <SalesManageStaticsTeamContainer
            selectedYear={selectedYear}
            selectedCompany={companyCd}
            searchData={searchData}
            tableRef={dpTableRef}
          />
        )}
        {type === 'employee' && (
          <SalesManageStaticsEmpContainer
            selectedYear={selectedYear}
            selectedCompany={companyCd}
            searchData={searchData}
            tableRef={empTableRef}
          />
        )}
      </Box>
    </Box>
  );
};
export default SalesManageStaticsContainer;
